<!--
 * @Dscription: 
 * @version: 
 * @Author: 
 * @Date: 2019-09-29 10:26:58
 * @LastEditTime: 2019-10-14 10:26:33
 -->
<template>
  <!-- 员工管理 -->
  <div class="fillcontain">
    <div class="navCalss" style="margin-top: 20px">| 员工列表</div>
    <div class="search_container">
      <!-- 表单查找内容 -->
      <el-form
        :inline="true"
        :model="search_data"
        size="medium"
        ref="search_data"
        class="demo-form-inline search-form"
      >
        <el-form-item label="登录名:">
          <el-input
            v-model="searchData.keyWord"
            clearable
            placeholder="请输入真实姓名"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机号:" prop="mobile">
					<el-input v-model="searchData.keyWord2" placeholder="请输入手机号/电话号" maxlength="11"></el-input>
				</el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="search" @click="getAdminList('1')"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item class="btnRight">
          <el-button
            type="primary"
            icon="view"
            @click="
              () => {
                searchData = { keyWord: '' };
                getAdminList();
              }
            "
            >重置</el-button
          >
        </el-form-item>
        <el-form-item class="btnRight">
          <el-button type="primary" @click="onAddAdmin()">创建员工</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_container">
      <!-- 遍历所有员工信息 -->
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        size="medium"
      >
        <el-table-column
          prop="adminId"
          label="序号"
          align="center"
          min-width="100px"
        >
          <template slot-scope="scope">
            <span v-text="getIndex(scope.$index)"> </span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="用户名" align="center">
        </el-table-column>
        <el-table-column label="真实姓名" align="center" min-width="200px">
          <template slot-scope="scope">
            {{ scope.row.realName }}
          </template>
        </el-table-column>

        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="200px"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="roleName" label="角色类别" min-width="200px" align='center' v-if="companyId==0">
				</el-table-column> -->

        <el-table-column
          prop="operation"
          align="center"
          label="操作"
          fixed="right"
          min-width="300px"
        >
          <template slot-scope="scope">
            <div style="display: flex">
              <div style="flex: 6">
                <el-button type="text" @click="onEditAdmin(scope.row, '2')"
                  >查看</el-button
                >
              </div>
              <div style="flex: 6">
                <el-button type="text" @click="onEditAdmin(scope.row)"
                  >编辑</el-button
                >
              </div>
              <div style="flex: 6">
                <el-button type="text" @click="onEditAdmin(scope.row, '3')"
                  >修改密码</el-button
                >
              </div>
              <div style="flex: 6">
                <el-button type="text" @click="onDelAdmin(scope.row.adminId)"
                  ><span style="color: red">删除</span></el-button
                >
              </div>
            </div>
            <!-- <el-dropdown trigger="click">
							<span class="el-dropdown-link" style="margin-left:10px; cursor:pointer">更多操作</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native='deleteAdmin(scope.row,scope.$index)' v-if="scope.row.roleType==1?false:true">删除</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-row style="margin-top: 20px">
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              :page-sizes="paginations.page_sizes"
              :page-size="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
              :current-page="paginations.page_index"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 弹出微信二维码 -->
    <!--  -->
    <!-- 弹出修改对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialog.showC"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
    >
      <div class="form">
        <el-form
          :model="employee.netBarForm"
          :rules="employee.form_rules"
          ref="netBarForm"
          :label-width="employee.formLabelWidth"
          style="margin: 20px; width: auto"
          label-position="right"
        >
          <!-- 客户基础信息 -->
          <el-form-item prop="password" label="密码:">
            <el-input
              v-model="employee.netBarForm.password"
              placeholder="请输入密码"
              style="width: 308px"
              type="password"
            ></el-input>
          </el-form-item>

          <el-form-item prop="passwordA" label="确认密码:">
            <el-input
              v-model="employee.netBarForm.passwordA"
              placeholder="请再输入一次密码"
              style="width: 308px"
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>

        <div style="margin: 0 150px">
          <el-button type="primary" @click="onsumbitB()">提交</el-button>
          <el-button @click="dialog.showC = false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 弹出修改对话框 -->
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="500px"
    >
      <div class="form">
        <el-form
          :model="employee.netBarForm"
          :rules="employee.form_rules"
          ref="netBarForm"
          :label-width="employee.formLabelWidth"
          style="margin: 20px; width: auto"
          label-position="right"
        >
          <!-- 客户基础信息 -->

          <el-form-item prop="userName" label="账户名称:">
            <el-input
              v-model="employee.netBarForm.userName"
              placeholder="请输入账户名称"
              style="width: 308px"
            ></el-input>
          </el-form-item>

          <el-form-item prop="password" label="密码:" v-if="showOnsub">
            <el-input
              v-model="employee.netBarForm.password"
              placeholder="请输入密码"
              style="width: 308px"
              type="password"
            ></el-input>
          </el-form-item>

          <el-form-item prop="passwordA" label="确认密码:" v-if="showOnsub">
            <el-input
              v-model="employee.netBarForm.passwordA"
              placeholder="请再输入一次密码"
              style="width: 308px"
              type="password"
            ></el-input>
          </el-form-item>

          <el-form-item label="真实姓名:">
            <el-input
              v-model="employee.netBarForm.realName"
              placeholder="请输入真实姓名"
              style="width: 308px"
            ></el-input>
          </el-form-item>

          <el-form-item prop="mobile" label="手机:">
            <el-input
              maxlength="11"
              placeholder="请输入手机号码"
              v-model="employee.netBarForm.mobile"
              style="width: 308px"
              @keyup="this.value = this.value.replace(/[^\d]/g, '')"
            ></el-input>
          </el-form-item>

          <el-form-item prop="roleId" label="角色类型:" v-if="showOnsub">
            <el-select
              v-model="employee.netBarForm.roleId"
              placeholder="请选择角色类型"
              style="width: 308px"
            >
              <el-option
                label="系统管理员"
                :value="1"
              ></el-option>
              <el-option
                label="快递点管理员"
                :value="4"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <div style="margin: 0 150px">
          <el-button type="primary" @click="onsumbit()" v-if="showOnsub"
            >提交</el-button
          >
          <el-button
            @click="dialog.show = false"
            :class="showOnsub ? '' : 'margiLeft'"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- //确认移除 -->
    <el-dialog
      :visible.sync="dialog.showB"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="340px"
      center
    >
      <div style="text-align: center">
        <span>您确定删除该员工信息？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteItem(indexA)">移除</el-button>
        <el-button @click="dialog.showB = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as mUtils from "utils/mUtils";
import * as admin from "@/api/admin.js";
import { axios } from "utils/";

export default {
  data() {
    let dataValidate = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "userName") {
          text = "账户名称";
        } else if (rule.field == "realName") {
          text = "真实姓名";
        } else if (rule.field == "mobile") {
          text = "联系电话";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        // if (rule.field == "mobile") {
        //   let numReg = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
        //   if (!numReg.test(value)) {
        //     callback(new Error("请输入正确的手机号"));
        //   }
        // }
        return callback();
      }
    };

    // <!--验证密码-->
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.employee.netBarForm.passwordA !== "") {
          this.$refs.netBarForm.validateField("passwordA");
        }
        callback();
      }
    };
    // <!--二次验证密码-->
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.employee.netBarForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      showOnsub: true,
      adminId: "",

      indexB: "",
      statusA: "",
      searchData: {
        keyWord: "",
        keyWord2: "",
      },
      indexA: "",
      rowDmind: "",
      dadBool: false,
      options: [],
      tableData: [], //表格信息
      //创建管理员dialog
      dialog: {
        width: "300px",
        show: false,
        showC: false,
        title: "创建员工",
        formLabelWidth: "120px",
        showB: false,
        showC: false,
      },
      employee: {
        width: "300px",
        show: false,
        title: "",
        formLabelWidth: "120px",
        appendOrUpdate: 1, //1/2 添加/更改
        netBarForm: {
          roleType: "",
          userName: "",
          realName: "",
          password: "",
          passwordA: "",
          tel: "",
          fax: "",
          //角色选择的值
          value: "",
          mobile: "",
          message: "",
          roleId: null,
        },
        //信息修改规则
        form_rules: {
          userName: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          realName: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          password: [
            { required: true, validator: validatePass, trigger: "change" },
            {
              required: true,
              message: "密码不能为空",
              trigger: "blur",
            },
          ],
          passwordA: [
            { required: true, validator: validatePass2, trigger: "change" },
            {
              required: true,
              message: "密码不能为空",
              trigger: "blur",
            },
          ],
          // role:[{
          // 	required: true,

          // 	trigger: 'blur'
          // }],

          mobile: [
            {
              required: true,
              validator: dataValidate,
              trigger: "blur",
            },
          ],
          roleId: [
            {
              required: true,
              message: "请选择角色类型",
              trigger: "change",
            },
          ],
        },
      },
      search_data: {
        //搜索内容
        realName: "",
        mobile: "",
      },
      updateOrAdd: 0, //dialog submit是创建1还是更新数据0 (ps:因为创建和更新共用一个dialog)
      paginations: {
        //分页数据
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 15, 20], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
    };
  },
  created() {
    let that = this;
    this.getAdminList();
  },
  methods: {
    //获取表格序号
    getIndex($index) {
      //表格序号
      return (
        (this.paginations.page_index - 1) * this.paginations.page_size +
        $index +
        1
      );
    },
    // 状态改变
    startEnd(adminId, status) {
      this.indexB = adminId;
      this.statusA = status;
      this.dialog.showC = true;
    },

    deleteItem(admind) {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        adminId: admind,
        operatorId: mUtils.getStore("userinfo").adminId,
      };
      admin.adminDelete(data).then(function (res) {
        if (res.data.code != 0) {
          let msg;
          msg = "删除个人信息失败!";
          that.$message.error(msg);

          loading.close();
          return;
        } else {
          that.$message.success("删除个人信息成功！");
          that.dialog.showB = false;
          that.getAdminList();
          loading.close();
        }
      });
    },
    onDelAdmin(val) {
      let that = this;
      that.dialog.showB = true;
      that.indexA = val;
    },
    //修改密码
    onsumbitB() {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      let data = {};

      let validd;
      that.$refs.netBarForm.validate((valid) => {
        validd = valid;

        return true;
      });

      if (validd) {
        data = {
          adminId: that.adminId,
          password: that.$md5(that.employee.netBarForm.password),
          operatorId: mUtils.getStore("userinfo").adminId,
        };
        admin.updatePwd(data).then(function (res) {
          if (res.data.code != 0) {
            if (res.data.code == 1101) {
              let msg;
              msg = res.data.msg;
              that.$message.error(msg);
            } else if (res.data.code == 120) {
              let msg;
              msg = res.data.msg;
              that.$message.error(msg);
            } else {
              let msg;
              msg = "保存失败!";
              that.$message.error(msg);
            }
            loading.close();
            return;
          } else {
            let msg;
            msg = "保存成功 !";
            that.$message({
              message: msg,
              type: "success",
            });
            that.dialog.showC = false;
            that.getAdminList();
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    //提交表单
    onsumbit() {
      let that = this;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });
      setTimeout(function () {
        loading.close();
      }, 5000);
      let data = {};

      let validd;
      that.$refs.netBarForm.validate((valid) => {
        validd = valid;

        return true;
      });

      if (validd) {
        data = {
          adminId: that.adminId ? that.adminId : null,
          userName: that.employee.netBarForm.userName,
          password: that.$md5(that.employee.netBarForm.password),
          realName: that.employee.netBarForm.realName
            ? that.employee.netBarForm.realName
            : null,
          roleId: that.employee.netBarForm.roleId,
          mobile: that.employee.netBarForm.mobile,
        };
        admin.adminAdd(data).then(function (res) {
          console.log(res);
          if (res.data.code != 0) {
            if (res.data.code == 1101) {
              let msg;
              msg = res.data.msg;
              that.$message.error(msg);
            } else if (res.data.code == 120) {
              let msg;
              msg = res.data.msg;
              that.$message.error(msg);
            } else {
              let msg;
              msg = "保存失败!";
              that.$message.error(msg+res.data.msg);
            }
            loading.close();
            return;
          } else {
            let msg;
            msg = "保存成功 !";
            that.$message({
              message: msg,
              type: "success",
            });
            that.dialog.show = false;
            that.getAdminList();
            loading.close();
          }
        });
      } else {
        that.$message.error("表单输入错误 !");
        loading.close();
        return false;
      }
    },
    /**
     * @name
     * @param
     * @return
     * @description 判断是否登录
     */
    // isLogin() {
    // 	if(mUtils.getToken()==null){this.$router.push('/login')}
    // 	else{
    // 		this.getAdminList();
    // 	}
    // },
    /**
     * @name
     * @param search_data
     * @description 传search_data到getAdminList()
     */
    onSearch(search_data) {
      this.getAdminList();
    },
    /**
     * @name
     * @description 清空search_data内容，重新获取列表
     */
    resetForm() {
      let that = this;
      that.search_data.realName = "";
      that.search_data.mobile = " ";
      that.getAdminList();
    },

    /**
     * @name
     * @description 获取员工列表
     * @main_method post(url,data)
     * @interface getAdminList
     */
    getAdminList(dataA) {
      let that = this;

      let data = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        userName: that.searchData.keyWord ? that.searchData.keyWord : null,
      };

      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      admin.getAdminList(data).then(function (res) {
		loading.close();
        if (res.data.code == 1202){
            that.$router.push('/login')
            return
        }
        if (res.data.code != 0) {
          that.$message.error("获取列表失败");
          return;
        } else {
          that.tableData = res.data.data.list;
          that.paginations.total = res.data.data.pageCount;
        }
      });
      loading.close();
    },
    /**
     * @description 打开管理员dialog
     * @main_param dialog.show, updateOrAdd
     */
    onAddAdmin() {
      let that = this;
      const formdata = this.form;
      for (let key in formdata) {
        formdata[key] = "";
      }
      (that.employee.netBarForm.userName = ""),
        (that.employee.netBarForm.password = "");
      that.employee.netBarForm.passwordA = "";
      that.employee.netBarForm.realName = "";
      that.employee.netBarForm.mobile = "";
      that.employee.netBarForm.roleId = null; // Reset role selection
      
      this.dialog.title = "创建员工";
      this.dialog.show = true;
      this.updateOrAdd = 1; //updateOrAdd = 1 表示添加
    },
    /**
     * @description 打开管理员dialog, 传参到this.form
     */
    onEditAdmin(res, i) {
      let that = this;
      that.adminId = res.adminId;
      if (i == 3) {
        that.employee.netBarForm.password = "";
        that.employee.netBarForm.passwordA = "";
        that.dialog.showC = true;
      } else {
        that.employee.netBarForm.userName = res.userName;
        that.employee.netBarForm.password = res.password;
        that.employee.netBarForm.passwordA = res.password;
        that.employee.netBarForm.roleId = res.roleId;
        if (i == 2) {
          that.showOnsub = false;
          that.dialog.title = "查看员工信息";
        } else {
          that.showOnsub = true;
          that.dialog.title = "修改员工信息";
        }

        that.employee.netBarForm.realName = res.realName;
        that.employee.netBarForm.mobile = res.mobile;

        //   that.getAdminList()

        this.updateOrAdd = 0;

        this.dialog.show = true;
      }
    },
    /**
     * @description 管理员dialog确认
     * @main_param updateOrAdd(0||1), form(提交表单内容)
     */
    onSubmit(form) {
      let that = this;
      that.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let parameter = {
            realName: that.form.realName,
            mobile: that.form.mobile,
            position: that.form.position,
            remark: that.form.remark,
          };
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (that.updateOrAdd == 1) {
            //pdateOrAdd == 1 新增
            parameter.adminId = mUtils.getUserId();
            that.$sub
              .post("/v1/market/admin/addAdmin", parameter)
              .then(function (res) {
				loading.close();
				if (res.data.code == 1202){
					that.$router.push('/login')
					return
				}  
                if (res.data.code != 0) {
                  that.$message.error(res.data.msg || "操作失败");
                  return;
                }
                that.$message({
                  message: "新增成功",
                  type: "success",
                });
                loading.close();
                that.getAdminList();
                that.dialog.show = false;
              });
          } else if (that.updateOrAdd == 0) {
            //updateOrAdd == 0 更改
            parameter.adminId = that.form.adminId;
            that.$sub
              .post("/v1/market/admin/updateAdminInfo", parameter)
              .then(function (res) {
                if (res.data.code != 0) {
                  that.$message.error(res.data.msg || "操作失败");
                  return;
                }
                that.$message({
                  message: "更改成功",
                  type: "success",
                });
                that.getAdminList();
                that.dialog.show = false;
              });
            loading.close();
          }
        }
      });
    },

    //删除admin时打开确认dialog
    deleteAdmin(row) {
      this.form.adminId = row.adminId;
      this.deleteOrNot = true;
    },
    /**
     * @description 删除admin确认
     */
    onDeleteAdmin() {
      let that = this;
      let data = {
        adminId: that.form.adminId,
        status: -1, //传参后端状态代表删除
        token: mUtils.getToken(),
      };
      that.$sub
        .post("/v1/market/admin/updateAdminStatus", data)
        .then(function (res) {
          if (res.data.code != 0) {
            that.$message.error(res.data.msg || "操作失败");
            return;
          }
          that.$message({
            message: "删除成功",
            type: "success",
          });
          that.getAdminList();
          setTimeout(() => {
            location.href = document.URL;
          }, 1000);
        });
      that.deleteOrNot = false; //关闭确认删除dialog
    },
    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.getAdminList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      that.getAdminList();
    },
  },
};
</script>

<style lang="less" scoped>
.fillcontain {
  // margin-left: 30px;
  margin: 40px 40px 80px 40px;
}

.search-form {
  // width: 100%;
  // min-width: 750px;
  margin-top: 20px;
  margin-bottom: 10px;

  .el-form-item {
    margin-bottom: 10px !important;

    .el-date-editor {
      width: 200px;
    }
  }
}

.el-dialog--small {
  width: 600px !important;
  display: none;
  display: block;
}

.pagination {
  text-align: center;
  margin-top: 30px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.margiLeft {
  margin-left: 5vw;
  background-color: #409eff;
  color: white;
}
</style>


// WEBPACK FOOTER //
// adminList.vue?041283c0